/*
  GA4 events for the things this business actually gets judged on: contact taps, the
  delivery slot, and the shop funnel. The gtag config itself is the client's own and
  already sits in the layout, so this file only sends events.

  Every call is wrapped: if gtag is missing, blocked by an ad blocker, or throws, the
  page carries on untouched. Nothing here may ever break a checkout.
*/
(function () {
  'use strict';

  // Shopify's own pixel already reports ecommerce to the Google Ads and Merchant Center
  // IDs with an explicit send_to. Ours therefore go to the GA4 property only, so nothing
  // is counted twice. The measurement id is read off the client's own gtag config.
  var ga4 = null, ga4Read = false;
  function ga4Target() {
    if (ga4Read) return ga4;
    ga4Read = true;
    try {
      var dl = window.dataLayer || [];
      for (var i = 0; i < dl.length; i++) {
        var a = dl[i];
        if (a && a[0] === 'config' && typeof a[1] === 'string' && a[1].indexOf('G-') === 0) { ga4 = a[1]; break; }
      }
    } catch (e) {}
    return ga4;
  }

  function send(name, params) {
    try {
      if (typeof window.gtag !== 'function') return;
      var p = params || {};
      var to = ga4Target();
      if (to && !p.send_to) p.send_to = to;
      window.gtag('event', name, p);
    } catch (e) { /* analytics must never surface to a customer */ }
  }
  window.dxTrack = send;

  var money = function (cents) { return Math.round((cents || 0)) / 100; };

  // ---- contact taps -------------------------------------------------------
  // Delegated, so it covers the sticky WhatsApp button, the header phone number,
  // the footer, and anything added later by a section or an app.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var where = a.closest('.dx-hd') ? 'header'
      : a.closest('.dx-ft') ? 'footer'
      : a.closest('.dx-hero') ? 'hero'
      : a.closest('[class*="float"], [id*="whatsapp"], [class*="whatsapp"]') ? 'floating button'
      : 'page';
    if (/wa\.me|api\.whatsapp\.com|web\.whatsapp\.com/i.test(href)) {
      send('whatsapp_click', { link_url: href, link_location: where, page_path: location.pathname });
    } else if (/^tel:/i.test(href)) {
      send('phone_click', { link_url: href, link_location: where, page_path: location.pathname });
    } else if (/^mailto:/i.test(href)) {
      send('email_click', { link_url: href, link_location: where, page_path: location.pathname });
    }
  }, true);

  // ---- catalogue clicks ---------------------------------------------------
  document.addEventListener('click', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.dx-cat .dx-card, .dx-cindex .dx-col') : null;
    if (!card) return;
    var name = (card.querySelector('h3, h4') || {}).textContent || '';
    send('select_item', { item_list_name: card.matches('.dx-col') ? 'Collection index' : 'Homepage catalogue', items: [{ item_name: name.trim() }] });
  }, true);

  // ---- add to cart --------------------------------------------------------
  // Refresh adds to cart with fetch, so wrap fetch rather than guess at a DOM event.
  // The original is always called and always returned untouched.
  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var promise = nativeFetch.apply(this, arguments);
      if (/\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url)) {
        try {
          promise.then(function (res) {
            if (!res || !res.ok || !res.clone) return null;
            return res.clone().json().catch(function () { return null; });
          }).then(function (cart) {
            if (cart && typeof cart.total_price === 'number') window.dxCartTotal = cart.total_price;
          }).catch(function () {});
        } catch (e) {}
      }
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        try {
          promise.then(function (res) {
            if (!res || !res.ok || !res.clone) return null;
            return res.clone().json().catch(function () { return null; });
          }).then(function (data) {
            if (!data) return;
            var items = data.items || [data];
            var value = 0, mapped = [];
            for (var i = 0; i < items.length; i++) {
              var it = items[i]; if (!it || !it.product_title) continue;
              value += (it.final_line_price != null ? it.final_line_price : (it.price || 0) * (it.quantity || 1));
              mapped.push({
                item_id: String(it.product_id || it.id || ''),
                item_name: it.product_title,
                item_variant: it.variant_title || '',
                price: money(it.price),
                quantity: it.quantity || 1
              });
            }
            if (mapped.length) send('add_to_cart', { currency: 'SGD', value: money(value), items: mapped });
          }).catch(function () {});
        } catch (e) {}
      }
      return promise;
    };
  }

  // ---- the delivery slot --------------------------------------------------
  // dx-delivery.js announces every saved change. One event per settled state, not per
  // keystroke, because it already debounces before it saves.
  var lastSlot = '';
  document.addEventListener('dx:slot', function (e) {
    var d = (e && e.detail) || {};
    var key = [d.Fulfilment, d['Delivery zone'], d.date, d.boxtype, d.boxtype2, d['Referred by'] ? 'ref' : ''].join('|');
    if (key === lastSlot) return;
    lastSlot = key;
    send('delivery_slot_set', {
      fulfilment: d.Fulfilment || '',
      delivery_zone: d['Delivery zone'] || '',
      delivery_date: d.date || '',
      packing: d.boxtype || '',
      fillet_packing: d.boxtype2 || '',
      referred: d['Referred by'] ? 'yes' : 'no'
    });
    if (d['Referred by']) send('referral_named', { page_path: location.pathname });
  });

  // ---- checkout -----------------------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[name="checkout"], a[href="/checkout"], a[href^="/checkouts/"]') : null;
    if (!btn) return;
    send('begin_checkout', { currency: 'SGD', value: money(window.dxCartTotal), page_path: location.pathname });
  }, true);
})();
